import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RequestMoneyService } from '../request-money.service';

@Component({
  selector: 'app-request-step3',
  templateUrl: './request-step3.component.html',
  styleUrls: ['./request-step3.component.scss']
})
export class RequestStep3Component implements OnInit {
  @ViewChild('requestForm') requestForm: NgForm;
  constructor(public requestMoneyervice:RequestMoneyService) { }

  ngOnInit(): void {
    if(!this.requestMoneyervice.step1Data || !this.requestMoneyervice.step2Data){
      this.requestMoneyervice.goTo("step1")
    }
    setTimeout(() => {
      if(this.requestMoneyervice.step2Data){
        this.requestForm.setValue(this.requestMoneyervice.step2Data)
      }
   }, );
  }

  goNext(){
    this.requestMoneyervice.common.showLoader()
    this.requestMoneyervice.sendRequest().subscribe(res=>{
      //console.log(res)
      this.requestMoneyervice.common.stopLoader()
      this.requestMoneyervice.goTo('step4')
    },err=>{
      //console.log(err)
      this.requestMoneyervice.common.stopLoader()
      alert("error")
    })
  }

  goBack(){
    this.requestMoneyervice.goTo('step2')
  }

}
